const noop = () => {
  // pass
};

export default noop;
